export default {
  init() {
    // JavaScript to be fired on all pages

    jQuery(function ($) {
        $('.navbar-toggler').click(function () {
          $('#top-header').toggleClass('header--open');
        })
    });

    jQuery('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .click(function(event) {
          // On-page links

          var _href = $(this).attr('href').replace('#', '');
          if ($.isNumeric(_href)) {
              return true;
          }

          if (
              location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
              &&
              location.hostname == this.hostname
          ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {
                  // Only prevent default if animation is actually gonna happen
                  event.preventDefault();
                  jQuery('html, body').animate({
                      scrollTop: target.offset().top - 80,
                  }, 1000, function() {
                      // Callback after animation
                      // Must change focus!
                      var $target = $(target);
                      $target.focus();
                      if ($target.is(':focus')) { // Checking if the target was focused
                          return false;
                      } else {
                          $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                          $target.focus(); // Set focus again
                      }
                  });
              }
          }
      });

    jQuery(window).load(function()
    {
        var container = '.post-list';
        var button = '.nav-links .nav-previous a';
        jQuery(document).on('click', button, function (e) {
            e.preventDefault();
            var $this = jQuery(e.currentTarget);
            $this.addClass('disabled');
            jQuery.get($this.attr('href'), function (data) {
                var data_to_add = jQuery(container + ' > div', data);
                jQuery(container).append(data_to_add);
                jQuery(document).trigger('pagination_load', [data_to_add]);
                if (jQuery(button, data).length < 1) {
                    $this.remove();
                } else {
                    $this.removeClass('disabled');
                    $this.attr('href', jQuery(button, data).attr('href'));
                }
            });
        });
    });

    jQuery(document).on('click', '.js-toggle', function() {

        var $this = $(this);
        var $target;
        var target = $this.data('target');

        if (target) {
            $target = $(target);
        } else {
            $target = $this.closest('.js-toggleable');
        }

        $target.toggleClass('is-active');

    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js